export const SET_IS_PAYING = 'SET_IS_PAYING'
export const SET_IS_CORP_DIALOG_OPENED = 'SET_IS_CORP_DIALOG_OPENED'
